import { IPortalReportingPeriodApplicantDocumentService } from "../../service/document/PortalReportingPeriodApplicantDocumentService";

export default class GetPortalReportingPeriodApplicantDocumentsInteractor {
  private portalReportingPeriodApplicantDocumentService: IPortalReportingPeriodApplicantDocumentService;

  constructor(portalReportingPeriodApplicantDocumentService) {
    this.portalReportingPeriodApplicantDocumentService =
      portalReportingPeriodApplicantDocumentService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.portalReportingPeriodApplicantDocumentService.getReportingPeriodApplicantDocuments(
      reportingPeriodApplicantId
    );
  }
}
